"use strict";
module.exports = Object.freeze({
    EXPRESSION: 'expression',
});
//# sourceMappingURL=conditionType.js.map